import InfoIcon from "./InfoIcon";
import CloseIcon from "./CloseIcon";
import GalleryIcon from "./GalleryIcon";
import UploadIcon from "./UploadIcon";
import TextIcon from "./TextIcon";
import MobileIcon from "./MobileIcon";
import CheckIcon from "./CheckIcon";
import RoundCheckIcon from "./RoundCheckIcon";
import PlayIcon from "./PlayIcon";
import PreviewIcon from "./Preview";
import ProcessingIcon from "./Processing";
import FramesIcon from "./FramesIcon";
import UndoIcon from "./UndoIcon";
import RedoIcon from "./RedoIcon";
export var Info = InfoIcon;
export var Close = CloseIcon;
export var Gallery = GalleryIcon;
export var Upload = UploadIcon;
export var Text = TextIcon;
export var Mobile = MobileIcon;
export var Check = CheckIcon;
export var RoundCheck = RoundCheckIcon;
export var Play = PlayIcon;
export var Preview = PreviewIcon;
export var Processing = ProcessingIcon;
export var Frames = FramesIcon;
export var Undo = UndoIcon;
export var Redo = RedoIcon;